export default "__VITE_ASSET__bwCfYH0b__"